module.exports = __webpack_public_path__ + "static/media/competitiveyouth.94f68ba1.jpg";